import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getVisibleTabs } from "../controllers/tabController";
import { DEFAULT_LANDING_PATH, resolveLandingPath } from "../utils/landingPath";

// "/" lands here: send the user to the first tab enabled for their account
// instead of assuming everyone has Live.
const LandingRedirect = () => {
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (!token || token === "undefined") return undefined;

    let cancelled = false;
    getVisibleTabs(username)
      .then((tabs) => {
        if (!cancelled) setTarget(resolveLandingPath(tabs));
      })
      .catch(() => {
        // Backend unreachable: fail open like the Header does.
        if (!cancelled) setTarget(DEFAULT_LANDING_PATH);
      });
    return () => {
      cancelled = true;
    };
  }, [token, username]);

  if (!token || token === "undefined") return <Navigate to="/login" replace />;
  if (!target) return null;
  return <Navigate to={target} replace />;
};

export default LandingRedirect;
